import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import {
  GridComponent,
  QueryCellInfoEventArgs,
} from "@syncfusion/ej2-angular-grids";
import { TooltipComponent } from "@syncfusion/ej2-angular-popups";
import { Subscription } from "rxjs";
import { ISplMessage, ISplValidation } from "../../../shared/models";

@Component({
    selector: "app-error-messages",
    templateUrl: "./error-messages.component.html",
    styleUrls: ["./error-messages.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorMessagesComponent implements OnChanges, OnDestroy {
  splErrorMessages: ISplMessage[] = [];
  @ViewChild("errorGrid")
  public errorGrid: GridComponent;
  @Input() splValidationMessages: ISplValidation;

  // CustomAttributes to handle changing color of the text (Error vs Warning)
  public customAttributes: Object;

  @ViewChild("tooltip", { static: true })
  public tooltipObj: TooltipComponent;

  isHideErrorsWarnings = false;
  sub: Subscription;
  public clipmodecolumn = { class: "e-tooltipcolumn" };
  defaultDisplay = "hide";

  constructor(private sanitizer: DomSanitizer) {}

  tooltipValue(args) {
    let grid;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {
      grid = this.errorGrid;

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltipObj.content = rowData[(rowInfo.column as any).field];
    }
  }

  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.data["messageType"] === "Error") {
      args.cell.classList.add("customcssError");
    } else if (args.data["messageType"] === "Warning") {
      args.cell.classList.add("customcssWarning");
    }
  }

  showMessages(splValidation: ISplValidation) {
    if (
      splValidation
      && splValidation.validationMessages
      && splValidation.validationMessages.messages.length > 0
    ) {
      this.splErrorMessages = splValidation.validationMessages.messages;
    }

    this.errorGrid.refresh();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const property in changes) {
      if (
        property === "splValidationMessages" &&
        changes[property].currentValue
      ) {
        if (
          this.splValidationMessages &&
          this.splValidationMessages.validationMessages &&
          this.splValidationMessages.validationMessages.messages.length > 0
        ) {
          this.splErrorMessages = this.splValidationMessages.validationMessages.messages;
          if (!this.splErrorMessages || this.splErrorMessages.length === 0) {
            this.defaultDisplay = 'hide';
          }
        }
      }
    }
  }

  showHideErrorsWarnings() {
    this.isHideErrorsWarnings = !this.isHideErrorsWarnings;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
